var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.62.071c.31-.12.66-.09.94.1.27.19.44.5.44.83v13.88c0 .41-.25.78-.64.93l-9 3.48h-.03a.96.96 0 01-.33.06.96.96 0 01-.33-.06h-.03l-9-3.48a.994.994 0 01-.64-.93V1.001c0-.33.16-.64.44-.83.28-.18.63-.22.94-.1L10 3.591l8.62-3.52zm-15.05 9h3.86v-2H3.57v2zm7.43 7.82l7-2.7v-11.7l-7 2.85v11.55zm1.57-9.82h3.86v2h-3.86v-2z"
  })));
}
export default SvgGuide;